import { Observable } from "rxjs";
import { connect, disconnect, StompActionskeys } from "./actions";
import { ActionKeys } from "../user/actionTypes";
export { StompActionskeys };
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["CONNECTED"] = 0] = "CONNECTED";
    ConnectionStatus[ConnectionStatus["DISCONNECTED"] = 1] = "DISCONNECTED";
})(ConnectionStatus || (ConnectionStatus = {}));
export function createStompBroker(observerStomp) {
    const actions = { connect, disconnect };
    const reducer = (state = { status: ConnectionStatus.DISCONNECTED }, action) => {
        switch (action.type) {
            case StompActionskeys.CONNECTED:
                return { status: ConnectionStatus.CONNECTED };
            case StompActionskeys.DISCONNECTED:
                return { status: ConnectionStatus.DISCONNECTED };
            default:
                return state;
        }
    };
    const isConnected = (state) => state.status === ConnectionStatus.CONNECTED;
    const selectors = { isConnected };
    const connectionEpic = () => Observable.merge(observerStomp
        .map((res) => {
        return res.connected ? connect() : disconnect();
    })
        .catch(() => Observable.of(disconnect())));
    const reconnectionEpic = (actions$, _, { stomp }) => actions$
        .ofType(ActionKeys.SET_USER)
        .do((action) => stomp.connect(action.payload))
        .mergeMap(() => Observable.empty());
    const middleware = [connectionEpic, reconnectionEpic];
    return { reducer, actions, selectors, middleware };
}
//# sourceMappingURL=index.js.map